<template>
    <div>
        <!-- {{ this.$route.params.id }} -->
        <b-card>
            <b-card-body>
                <div class="d-flex justify-content-between align-items-center">
                    <b-media class="mb-3">
                        <template #aside>
                            <img src="@/assets/img/icon_jobfair_2.png" alt="MUIC">
                        </template>
                        <h4 class="font-en mt-4">Company information</h4>
                    </b-media>
                    <b-button @click="backPage" size="sm" class="mr-1 ml-1" variant="danger" pill>Back to Homepage</b-button>
                </div>
                <hr>
                <!-- <pre>{{ DataCompany }}</pre> -->
                <div v-if="DataCompany.length != 0">
                    <p class="text-muted mt-0 mb-2 font-en"><i class="fa fa-photo mr-2" aria-hidden="true" />Company Logo</p>
                    <b-img 
                        v-if="DataCompany[0].logo !== null && DataCompany[0].logo !== 'null' && DataCompany[0].logo !== '' && DataCompany[0].logo !== 'NONE'" 
                        :src="DataCompany[0].logo" 
                        width="100" fluid thumbnail alt="IMAGE-COMPANY"
                    >
                    </b-img>
                    <p class="text-muted mt-4 mb-2 font-en"><i class="fa fa-building mr-2" aria-hidden="true" />Company Name</p>
                    <h5 class="font-th mt-2">{{ DataCompany[0].name }}</h5>
                    <!--  
                        <h5 class="font-th mt-2">Location :</h5>
                        <p class="text-justify mt-0 mb-5 text-r">
                            <span
                            v-if="!['',null,'null'].includes(DataCompany[0].location)"
                            style="font-size: 14px"
                            v-html="DataCompany[0].location"
                            ></span>
                            <span v-else>-</span>
                        </p>
                    -->
                    <div v-if="DataCompany[0].detail !== null && DataCompany[0].detail !== '' && DataCompany[0].detail !== '-'">
                        <p class="text-muted mt-0 mb-2 font-en">Job Description :</p>
                        <p class="text-justify mt-0 mb-0 text-r">
                            <span
                            style="font-size: 14px"
                            v-html="DataCompany[0].detail"
                            ></span>
                        </p>
                    </div>
                </div>
                <p class="text-muted mt-0 mb-2 font-en"><i class="fa fa-suitcase mr-2" aria-hidden="true" />List of Job Vacancies</p>
                <!-- <pre>{{ DataPosition }}</pre> -->
                <b-table
                    :fields="fields" 
                    :items="DataPosition"
                    responsive="sm"
                    head-variant=""
                    small show-empty bordered striped
                    class="mt-3"
                >
                    <template v-slot:cell(position)="row">
                        <h5 class="font-th mt-2 mb-0">[ {{ row.item.position_type }} ] : {{ row.item.position_name }}</h5>
                        <div v-if="row.item.detail !== null && row.item.detail !== 'null'">
                            <small>Job Description :</small>
                            <!-- <p class="mt-0 mb-1">
                                {{ row.item.detail }}
                            </p> -->
                            <p class="text-justify mt-0 mb-5 text-r">
                                <span
                                style="font-size: 14px"
                                v-html="row.item.detail"
                                ></span>
                            </p>
                        </div>
                        <div v-if="row.item.requirement !== null && row.item.requirement !== 'null'">
                            <small>Qualifications:</small>
                            <p class="text-justify mt-0 mb-5 text-r">
                                <span
                                style="font-size: 14px"
                                v-html="row.item.requirement"
                                ></span>
                            </p>
                        </div>
                        <div v-if="row.item.location !== null && row.item.location !== 'null'">
                            <small>Location:</small>
                            <p class="text-justify mt-0 mb-5 text-r">
                                <span
                                style="font-size: 14px"
                                v-html="row.item.location"
                                ></span>
                            </p>
                        </div>
                    </template>
                    <template v-slot:cell(expire_date)="row">
                        <span class="font-th">{{ moment(row.item.expire_date).format('LL') }}</span>
                    </template>
                    <template v-slot:cell(sendmail)="row">
                        <!-- position - id = {{ row.item.id }} --> <!-- {{ ViewBtnApply }} -->
                        <span v-if="ViewBtnApply">
                            <b-button size="sm" @click="conSentModal(row.item)" class="mr-1 ml-1" variant="info"><i class="fa fa-paper-plane" aria-hidden="true" /></b-button>
                        </span>
                        <strong v-else class="font-en text-danger">You are required to upload resume in your profile section.</strong>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
        <!-- modal pre submit -->
        <b-modal ref="bv-modal-Consent" id="bv-modal-Consent" hide-footer hide-header-close no-close-on-backdrop>
            <template v-slot:modal-title>
                <h5 class="text-danger font-en font-weight-bold mt-2 mb-0">I would like to apply for this position.</h5>
            </template>
            <b-alert show variant="info">
                <div v-if="DataCompany.length != 0">
                    <p class="text-muted mt-1 mb-2 font-en"><i class="fa fa-building mr-2" aria-hidden="true" />Company Name</p>
                    <h5 class="font-th mt-2">{{ DataCompany[0].name }}</h5>
                    <!-- <p class="text-muted mt-0 mb-0 font-en">Job Description :</p> -->
                    <!-- <p class="font-small-detail font-th mt-0 mb-4" v-html="DataCompany[0].detail"></p> -->
                    <p class="text-muted mt-0 mb-0 font-en">Position</p>
                    <p class="font-small-detail font-th mt-0 mb-4">{{ formDataConsent.position }}</p>
                </div>
            </b-alert>
            <div class="">
                <label class="font-en text-dark"><strong>When can you start ?</strong></label>
                <b-form-input class="font-en mb-3" v-model="formDataConsent.valueDate" type="date"></b-form-input>
                <label class="font-en text-dark"><strong>Consent</strong></label>
                <b-form-checkbox
                    class="font-en mb-0"
                    size="lg"
                    id="checkbox-1"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                    v-model="statusConsent"
                >
                    <p class="mt-0 mb-0"><strong class="font-en mb-2 mt-1">I accept the terms and use Consent to send information to the company.</strong></p>
                </b-form-checkbox>
                <p class="font-weight-bold mt-1 mb-1 text-danger">
                    We recommend not to apply for more than two jobs at the same company.
                </p>
                <!-- <div class="font-en mt-1 mb-2">State: <strong class="ml-2">{{ statusConsent }}</strong></div> -->
            </div>
            <hr>
            <div v-if="showDupplicate" class="text-left mt-2 mb-2">
                <strong class="font-en text-danger">You have already applied for this position. Please check your application status.</strong>
            </div>
            <div class="mt-3 mb-3 row">
                <div class="col-md-6">
                    <b-button size="sm" @click="sendDataToCompany(formDataConsent.idposition)" :disabled="statusConsent === 'not_accepted'" class="font-en mb-2" block variant="success">
                        <i class="fa fa-paper-plane mr-2" aria-hidden="true" /><strong class="text-light font-en">Yes</strong>
                    </b-button>
                </div>
                <div class="col-md-6">
                    <b-button size="sm" @click="closeModal" class="font-en mb-2" block variant="danger">
                        <i class="fa fa-times mr-2" aria-hidden="true" /><strong class="text-light font-en">No</strong>
                    </b-button>
                </div>
            </div>
        </b-modal>
        <!-- success modal -->
        <b-modal ref="my-success" centered  hide-footer hide-header-close>
            <template v-slot:modal-title>
                <h5 class="mt-1 mb-1 font-en">
                    <strong>Done</strong>
                </h5>
            </template>
            <b-alert class="font-form mt-2" show variant="success">
                <p class="font-en font-weight-bold mb-1 mt-1">Your profile information is about to be passed on to the company. Please check the status at "History Application".</p>
                <!-- <p class="font-en font-weight-bold mb-1 mt-1"></p> -->
            </b-alert>
            <hr>
            <b-button class="font-en mt-2" @click="closeModalSuccess" variant="danger">
               <i class="fa fa-times mr-2" aria-hidden="true" />Back to Homepage
            </b-button>
        </b-modal>
    </div>
</template>

<script>
    const objApply = {
        'idposition':'',
        'position':'',
        'valueDate': ''
    }
    export default {
        data(){
            return{
                formDataConsent: Object.assign({}, objApply),
                statusConsent: 'not_accepted',
                DataCompany:[],
                DataPosition:[],
                fields: [ 
                    { 
                        key: 'position',
                        label: 'List of Job Vacancies',
                        class: 'w-70',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                    { 
                        key: 'expire_date',
                        label: 'Expiry date ',
                        class: 'w-20',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                    { 
                        key: 'sendmail',
                        label: '',
                        class: 'text-center w-10',
                        thStyle: 
                        { 
                            fontFamily: 'Baloo Tamma 2',
                        } 
                    },
                ],
                ViewBtnApply:false,
                showDupplicate:'',
            }
        },
        computed: {
            getUrlIdCompany(){
                return this.$route.params.id !== '' ? this.$route.params.id : this.$router.push({ name:"NotFound" }).catch(err => {})
            }
        },
        mounted(){
            this.callCheckProfile()
            this.callInfomation()
        },
        methods:{
            backPage(){
                this.$router.push({
                    name:'Job Application',
                    // params: {
                    //     'tabAc':'aciveTab2'
                    // },
                }).catch(err => {})
            },
            showModalSuccess(){
                this.$refs['my-success'].show() 
            },
            closeModalSuccess(){
                this.$refs['my-success'].hide() 
            },
            conSentModal(objData){
                this.showDupplicate = ''
                this.formDataConsent.idposition = objData.id
                this.formDataConsent.position = objData.position_name
                this.formDataConsent.valueDate = this.moment().format('YYYY-MM-DD')
                this.$refs['bv-modal-Consent'].show() 
            },
            closeModal(){
                this.statusConsent = 'not_accepted'
                this.formDataConsent = Object.assign({}, objApply)
                this.$refs['bv-modal-Consent'].hide() 
            },
            chkBlankDataFile(val){
                return val !== "NONE" && val !== null && val !== 'null' && val !== ""
            },
            async callCheckProfile(){
                try {
                    const resProfile = await this.$http.get(`/career/application/`)
                    if(resProfile.status === 200){
                        if(this.chkBlankDataFile(resProfile.data[0].file_resume)){
                            this.ViewBtnApply = true
                        }else{
                            this.ViewBtnApply = false
                        }
                    }
                } catch (error) {}
            },
            async callInfomation(){
                // step 1 : call filter company
                this.DataCompany = []
                this.DataPosition = []
                try {
                    const res_0 = await this.$http.get(`/career/company/`)
                    if(res_0.status === 200){
                        this.DataCompany = res_0.data.filter(item => {
                            return item.id == this.getUrlIdCompany
                        }).map(result => {
                            return {
                                'id': result.id,
                                'name': result.name,
                                'email': result.email,
                                'tel': result.tel,
                                'detail': result.detail,
                                'logo': result.logo,
                                'location': result.location,
                            }
                        })
                        // step 2 : call position company
                        try {
                            const res_1 = await this.$http.get(`/career/company/${this.getUrlIdCompany}/job/`)
                            if(res_1.status === 200){
                                this.DataPosition = res_1.data.map(positionItem => {
                                    return {
                                        'id': positionItem.id,
                                        'company': positionItem.company,
                                        'position_name': positionItem.position_name,
                                        'position_type': positionItem.position_type,
                                        'location': positionItem.location,
                                        'detail': positionItem.detail,
                                        'requirement': positionItem.requirement,
                                        'status': positionItem.status,
                                        'expire_date': positionItem.expire_date,
                                    }
                                })
                                this.DataPosition.sort(function(a, b) {
                                    var nameA = a.position_name.toUpperCase();
                                    var nameB = b.position_name.toUpperCase();
                                    if (nameA < nameB) { return -1; }
                                    if (nameA > nameB) { return 1; }
                                    return 0;
                                });
                            }
                        } catch (error) {}
                    }
                } catch (error) {}
            },
            async sendDataToCompany(positionId){
                this.showDupplicate = ''
                try {
                    const setPositionSubmit = new FormData()
                    setPositionSubmit.append('position', positionId)
                    setPositionSubmit.append('start_work', this.formDataConsent.valueDate)
                    const response = await this.$http.post('/career/submit/', setPositionSubmit,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(response.status === 201){
                        this.showDupplicate = false
                        this.closeModal()
                        this.showModalSuccess()
                        // console.log(response.data)
                    }else if(response.status === 200){
                        // console.log(response.data.non_field_errors.length)
                        if(response.data.non_field_errors.length != 0){ this.showDupplicate = true }
                    }
                } catch (error) {}
            }
        },
    }
</script>

<style lang="scss" scoped>
    .font-th{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Baloo Tamma 2', cursive; }
    .w-10{ width: 10%; }
    .w-15{ width: 15%; }
    .w-20{ width: 20%; }
    .w-25{ width: 25%; }
    .w-50{ width: 50%; }
    .w-70{ width: 70%; }
    .alert-info {
        background-color: #e3f8ff;
        color: #000000;
    }
    .form-control {
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
        background-color:#ffffff;
        border: 1px solid #ced4da;
    }
    .readText-ps{
        font-family: 'Baloo Tamma 2', cursive;
        white-space: pre-line;
    }
    .f-textSize-1-ps{ font-size: 14px; }
    .text-r {
        white-space: pre-wrap;
    }
</style>